import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixQrCodeSectionProps } from "../types";

const PixQrCodeSection: React.FC<PixQrCodeSectionProps> = ({ qrCodeValue }) => {
  const classes = usePixModalStyles();

  if (!qrCodeValue) {
    return (
      <div className={classes.qrUnavailable}>
        <div className={classes.qrUnavailableIcon}>
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zm-5 0h3v3h-2v-1h-1v-2zm2 4h3v3h-2v-1h-1v-2zm2-1h2v-2h-2v2z" />
          </svg>
        </div>
        <span className={classes.qrUnavailableTitle}>QR Code indisponível</span>
        <p className={classes.qrUnavailableText}>
          O QR Code para este pedido não está disponível no momento. Tente
          atualizar ou entre em contato com o suporte.
        </p>
      </div>
    );
  }

  return (
    <div className={classes.qrBox}>
      <QRCodeCanvas value={qrCodeValue} size={150} includeMargin />
    </div>
  );
};

export default PixQrCodeSection;
